import { format } from "date-fns";
//  Old Safari browsers do not support the date format “yyyy-mm-dd”

export const dateOnlyWithoutTimezone = (dateString: string): Date => {
  const dt = new Date(dateString);
  // We always want to return the same date regardless of timezone
  // https://stackoverflow.com/questions/48172772/time-zone-issue-involving-date-fns-format
  const dtDateOnly = new Date(
    dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
  );
  return dtDateOnly;
};

export const formatDateTime = (isoString: string) => {
  return format(new Date(dateOnlyWithoutTimezone(isoString)), "MMMM d, yyyy");
};

export const formatDate = (dateString: string) => {
  try {
    const date = format(
      new Date(dateOnlyWithoutTimezone(dateString)),
      "MM/dd/yyyy",
    );
    return date;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(`Failed to format date: ${dateString}.
      Inner error: ${e.message}`);
    }
    throw new Error(`Failed to format date: ${dateString}`);
  }
};

export const pressFormatDate = (dateString: string): string =>
  format(new Date(dateOnlyWithoutTimezone(dateString)), "MMMM yyyy");

export const formatContentHubArticleDate = (dateString: string): string =>
  format(new Date(dateOnlyWithoutTimezone(dateString)), "MMM dd, yyyy");

export const getYearString = (date: Date | string): string =>
  format(new Date(date), "yyyy");

export const getDateAndTime = (date: Date | string): string => {
  return format(new Date(date), "MMM dd, yyyy hh:mm aa");
};
